import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

import { denormalizeCategorizedChanges } from './normalizers';

export interface PropagationResult {
  successCount: number;
  totalPlatforms: number;
  errors: string[];
}

/**
 * Get the count of child platforms for an HQ platform
 */
export const fetchChildPlatformCount = async (
  platformId: Identifier
): Promise<number> => {
  const response = await api.get(
    `/api/v4/platform_settings/child_platforms_count`,
    {
      params: { platform_id: platformId },
    }
  );
  return response.data.count;
};

/**
 * Propagate settings changes to all child platforms
 */
export const propagateSettings = async (
  platformId: Identifier,
  changedFields: Record<string, any>
): Promise<PropagationResult> => {
  // Denormalize the changed fields for server consumption
  const denormalizedChanges = denormalizeCategorizedChanges(changedFields);

  const response = await api.post(
    `/api/v4/platform_settings/propagate_settings`,
    {
      platform_id: platformId,
      changed_settings: denormalizedChanges,
    }
  );
  return camelcaseKeys(response.data);
};
